import { frontendURL } from '../../../../helper/URLHelper';
const SettingsWrapper = () => import('../SettingsWrapper.vue');
const WorkspaceFiles = () => import('./Index.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/files'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'workspace_files_index',
          component: WorkspaceFiles,
          meta: {
            permissions: ['administrator'],
            fullWidth: true,
          },
        },
      ],
    },
  ],
};
